(() => {
  if (window.cbFinderReady) return;
  window.cbFinderReady = true;

  const cache = {};
  const load = (src) => cache[src] || (cache[src] = fetch(src, { credentials: 'same-origin' })
    .then((r) => r.text())
    .then((t) => JSON.parse(t).map((r) => ({ url: r[0], title: r[1], price: r[2], img: r[3], form: r[4], occ: r[5], from: r[6] === 1, max: r[7] || r[2] })))
    .catch(() => { delete cache[src]; return []; }));

  const esc = window.cbEsc;
  const money = window.cbMoney;
  const short = (c) => '$' + Math.round(c / 100);
  const OCC = cbShop.occ;
  const STYLE = { bouquet: 'b', box: 'x' };
  // Budget bounds in cents from the site data center (CB Магазин → Flower Finder); keys stay as in old links
  const LOW = cbShop.budgetLow * 100, HIGH = cbShop.budgetHigh * 100;
  const BUDGET = { 'under-150': [0, LOW - 1, LOW], '150-250': [LOW, HIGH, HIGH], '250-plus': [HIGH + 1, 1e9, 0] };
  const fits = (p, occ, form) => (p.form === 'b' || p.form === 'x') && (!form || p.form === form) && (!occ || p.occ.indexOf(occ) >= 0);

  const card = (p, cls, extra) => '<a class="' + cls + '" href="' + esc(p.url) + '">' +
    '<span class="' + cls + '-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="480" height="600">' : '') +
    (extra ? '<span class="' + cls + '-tag">' + extra + '</span>' : '') + '</span>' +
    '<span class="' + cls + '-name">' + esc(p.title) + '</span>' +
    '<span class="' + cls + '-price">' + (p.from ? 'from ' : '') + money(p.price) + '</span></a>';

  const ICON_VASE = 'M18 7h12M19 7v5c0 3-6 6-6 15 0 8 4 14 11 14s11-6 11-14c0-9-6-12-6-15V7M14 24h20';
  const ICON_BOX = 'M10 18h28v20a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V18zM8 12h32v6H8zM20 12c0-5 8-5 8 0M16 9c2-3 6-2 8 3M32 9c-2-3-6-2-8 3';
  const ARW_L = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  const ARW_R = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  // Mouse drag on shelf rows: one pair of window listeners for all rows (rows are rebuilt on every chip)
  let drag = null;
  window.addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x;
    if (Math.abs(dx) > 5) { drag.row.cbMoved = true; drag.row.classList.add('is-dragging'); }
    if (drag.row.cbMoved) drag.row.scrollLeft = drag.left - dx;
  });
  window.addEventListener('pointerup', () => { if (drag) drag.row.classList.remove('is-dragging'); drag = null; });

  // Shelf rows: arrows, one tick per stop, mouse wheel and drag.
  const bindShelves = (box) => box.querySelectorAll('.cb-shelf').forEach((shelf) => {
    const row = shelf.querySelector('[data-cb-row]');
    const nav = shelf.querySelector('[data-cb-nav]');
    const tks = nav.querySelector('.cb-shelf__tks');
    const [prev, next] = nav.querySelectorAll('.cb-shelf__arw');
    const card = row.firstElementChild;
    const step = () => (card ? card.getBoundingClientRect().width + 12 : 160) * 3;
    const max = () => row.scrollWidth - row.clientWidth;
    const pages = () => Math.max(1, Math.ceil(max() / step() - 0.05) + 1);
    const to = (x) => row.scrollTo({ left: Math.max(0, Math.min(max(), x)), behavior: cbScroll() });
    const draw = () => {
      const n = pages();
      if (tks.children.length !== n) {
        tks.innerHTML = Array.from({ length: n }, (_, i) => '<button type="button" class="cb-shelf__tk" tabindex="-1" aria-label="' + (i + 1) + ' / ' + n + '"></button>').join('');
        Array.from(tks.children).forEach((t, i) => t.addEventListener('click', () => to(i * step())));
      }
      const cur = row.scrollLeft >= max() - 4 ? n - 1 : Math.round(row.scrollLeft / step());
      Array.from(tks.children).forEach((t, i) => t.classList.toggle('is-active', i === cur));
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= max() - 4;
      nav.hidden = max() <= 4;
    };
    prev.addEventListener('click', () => to(row.scrollLeft - step()));
    next.addEventListener('click', () => to(row.scrollLeft + step()));
    row.addEventListener('scroll', () => requestAnimationFrame(draw), { passive: true });
    row.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      const end = e.deltaY > 0 ? row.scrollLeft >= max() - 2 : row.scrollLeft <= 2;
      if (end) return;
      e.preventDefault();
      row.scrollLeft += e.deltaY;
    }, { passive: false });
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { row, x: e.clientX, left: row.scrollLeft };
      row.cbMoved = false;
    });
    row.addEventListener('click', (e) => { if (row.cbMoved) { e.preventDefault(); e.stopPropagation(); row.cbMoved = false; } }, true);
    row.addEventListener('dragstart', (e) => e.preventDefault());
    draw();
  });

  const finderUrl = (base, q) => {
    const u = new URL(base, location.origin);
    Object.keys(q).forEach((k) => { if (q[k]) u.searchParams.set(k, q[k]); });
    return u.pathname + u.search;
  };

  // Homepage strip: chips open a drawer (desktop) or shelves in place (mobile).
  document.querySelectorAll('[data-cb-strip]').forEach((root) => {
    const d = root.dataset;
    const chips = Array.from(root.querySelectorAll('[data-cb-occ]'));
    const inline = root.querySelector('[data-cb-inline]');
    const drawer = root.querySelector('[data-cb-drawer]');
    const dChips = drawer ? Array.from(drawer.querySelectorAll('[data-cb-occ]')) : [];
    const dTitle = drawer && drawer.querySelector('[data-cb-title]');
    const dBody = drawer && drawer.querySelector('[data-cb-shelves]');
    const dAll = drawer && drawer.querySelector('[data-cb-all]');
    const desktop = window.matchMedia('(min-width: 960px)');
    let current = null;
    let opener = null;

    // Escape the section's stacking context so the drawer covers the sticky header.
    if (drawer) {
      const host = root.closest('.section');
      if (host) drawer.setAttribute('style', host.getAttribute('style') || '');
      document.body.appendChild(drawer);
    }

    const shelves = (rows, slug, occ, label) => [['b', d.tVase, 'bouquet'], ['x', d.tBox, 'box']].map(([form, name, style], idx) => {
      const list = rows.filter((p) => fits(p, occ, form));
      if (!list.length) return '';
      const prices = list.map((p) => p.price);
      const all = finderUrl(d.finder, { for: slug, style });
      const cards = list.slice().sort((a, b) => a.price - b.price).slice(0, 8).map((p) => card(p, 'cb-shelf__card')).join('');
      return '<div class="cb-shelf"><div class="cb-shelf__head"><div class="cb-shelf__lead">' +
        '<svg class="cb-shelf__icon" style="--d:' + (0.1 + idx * 0.25) + 's" width="44" height="44" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path pathLength="1" d="' + (form === 'b' ? ICON_VASE : ICON_BOX) + '"/></svg>' +
        '<div class="cb-shelf__titles"><h3 class="cb-shelf__name">' + esc(name) + '</h3>' +
        '<span class="cb-shelf__meta">' + list.length + ' ' + esc(d.tFlowers) + ' · ' + short(Math.min(...prices)) + '–' + short(Math.max(...prices)) + '</span></div>' +
        '</div><a class="cb-shelf__see" href="' + all + '">' + esc(d.tAll) + ' ' + list.length + ' →</a></div>' +
        '<div class="cb-shelf__row" data-cb-row>' + cards + '<a class="cb-shelf__end" href="' + all + '"><span>' + esc(d.tAll) + ' ' + list.length + '</span><span aria-hidden="true">→</span></a></div>' +
        '<div class="cb-shelf__nav" data-cb-nav><button type="button" class="cb-shelf__arw" data-dir="-1" aria-label="Previous: ' + esc(name) + '">' + ARW_L + '</button>' +
        '<div class="cb-shelf__tks" aria-hidden="true"></div><button type="button" class="cb-shelf__arw" data-dir="1" aria-label="Next: ' + esc(name) + '">' + ARW_R + '</button></div></div>';
    }).join('') || '<p class="cb-shelf__empty">' + esc(d.tEmpty) + '</p>';

    const mark = (list, slug) => list.forEach((c) => {
      const on = c.dataset.cbOcc === slug;
      c.classList.toggle('is-selected', on);
      if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', on);
    });

    const render = (chip) => {
      const slug = chip.dataset.cbOcc;
      const occ = OCC[slug] || '';
      const label = chip.textContent.trim();
      current = slug;
      return load(d.src).then((rows) => {
        if (current !== slug) return;
        const html = shelves(rows, slug, occ, label);
        if (drawer && desktop.matches) {
          dTitle.textContent = d.tFor + ' ' + (occ ? label.toLowerCase() : d.tAnyDay);
          dBody.innerHTML = html;
          dBody.scrollTop = 0;
          requestAnimationFrame(() => bindShelves(dBody));
          dAll.href = finderUrl(d.finder, { for: slug });
          mark(dChips, slug);
        } else {
          inline.innerHTML = html;
          inline.hidden = false;
          bindShelves(inline);
        }
        mark(chips, slug);
      });
    };

    const openDrawer = () => {
      drawer.hidden = false;
      document.documentElement.classList.add('cb-drawer-open');
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        drawer.querySelector('.cb-fx__close').focus({ preventScroll: true });
      });
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('cb-drawer-open');
      setTimeout(() => { drawer.hidden = true; }, 300);
      if (opener) opener.focus({ preventScroll: true });
    };

    chips.forEach((chip) => chip.addEventListener('click', (e) => {
      e.preventDefault();
      opener = chip;
      if (drawer && desktop.matches) {
        dBody.innerHTML = '<p class="cb-shelf__empty">…</p>';
        openDrawer();
      }
      render(chip);
    }));
    dChips.forEach((chip) => chip.addEventListener('click', () => render(chip)));

    if (drawer) {
      drawer.querySelectorAll('[data-cb-close]').forEach((b) => b.addEventListener('click', closeDrawer));
      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawer();
        if (e.key !== 'Tab') return;
        const f = [...drawer.querySelectorAll('a[href], button:not([disabled])')].filter((n) => n.offsetParent !== null);
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // Warm the data when the strip comes into view.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(d.src); } }, { rootMargin: '200px' });
      io.observe(root);
    }
  });

  // Flower Finder page.
  document.querySelectorAll('[data-cb-finder]').forEach((root) => {
    const d = root.dataset;
    const params = new URLSearchParams(location.search);
    const state = { for: params.get('for') || '', style: params.get('style') || '', budget: params.get('budget') || '' };
    const groups = Array.from(root.querySelectorAll('[data-cb-q]'));
    const grid = root.querySelector('[data-cb-results]');
    const more = root.querySelector('[data-cb-more]');
    const stretchWrap = root.querySelector('[data-cb-stretch-wrap]');
    const stretch = root.querySelector('[data-cb-stretch]');
    const countEls = root.querySelectorAll('[data-cb-count]');
    const summary = root.querySelector('[data-cb-summary]');
    const PAGE = 24;
    let shown = PAGE;
    const pool = root.querySelector('[data-cb-pool]');
    const nodes = {};
    if (pool) pool.querySelectorAll('[data-cb-handle]').forEach((n) => { nodes[n.dataset.cbHandle] = n; });
    // Cards arrive in two parts, both sorted like the data: the first page at once, the rest once answers or "more" need it.
    const fetchCards = (src) => fetch(src, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-cb-handle]').forEach((n) => {
          const h = n.dataset.cbHandle;
          if (nodes[h]) return;
          nodes[h] = document.importNode(n, true);
          pool.appendChild(nodes[h]);
        });
      });
    let moreCards = pool && pool.dataset.cbPoolSrc ? null : Promise.resolve();
    const allCards = () => moreCards || (moreCards = fetchCards(pool.dataset.cbPoolSrc).catch(() => { moreCards = null; }));
    const firstCards = pool && pool.dataset.cbFirstSrc ? fetchCards(pool.dataset.cbFirstSrc).catch(() => allCards()) : Promise.resolve();
    const asked = () => !!(state.for || state.style || state.budget) || shown > PAGE;
    const nodeFor = (p) => nodes[p.url.split('/').pop()];
    const place = (target, list, tag) => {
      const keep = [];
      list.forEach((p) => {
        const n = nodeFor(p);
        if (!n) return;
        const old = n.querySelector('.cb-ff__card-tag');
        if (old) old.remove();
        if (tag) n.insertAdjacentHTML('beforeend', '<span class="cb-ff__card-tag">' + tag(p) + '</span>');
        keep.push(n);
      });
      Array.from(target.children).forEach((c) => { if (c.dataset.cbHandle) pool.appendChild(c); else c.remove(); });
      keep.forEach((n) => target.appendChild(n));
      return keep.length;
    };

    const sync = () => groups.forEach((g) => g.querySelectorAll('[data-v]').forEach((b) => {
      const on = state[g.dataset.cbQ] === b.dataset.v;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on);
    }));

    const draw = (rows) => {
      const occ = OCC[state.for] || '';
      const form = STYLE[state.style] || '';
      const range = BUDGET[state.budget];
      const base = rows.filter((p) => fits(p, occ, form));
      const list = range ? base.filter((p) => p.max >= range[0] && p.price <= range[1]) : base;
      countEls.forEach((el) => { el.textContent = list.length; });
      const labels = groups.map((g) => { const b = g.querySelector('[data-v="' + CSS.escape(String(state[g.dataset.cbQ] ?? '')) + '"]'); return b && b.dataset.v ? b.textContent.trim() : ''; }).filter(Boolean);
      summary.textContent = labels.length ? labels.join(' · ') : d.tEverything;
      const over = range && range[2] ? base.filter((p) => p.price > range[1] && p.price <= range[2] + cbShop.budgetStretch * 100 && nodeFor(p)).slice(0, 4) : [];
      place(stretch, [], null);
      const n = place(grid, list.slice(0, shown), null);
      if (!n) grid.insertAdjacentHTML('beforeend', '<p class="cb-ff__empty">' + esc(d.tEmpty) + '</p>');
      more.hidden = list.length <= shown;
      stretchWrap.hidden = !over.length;
      place(stretch, over, (p) => '+' + short(p.price - range[2]));
    };

    const update = () => {
      sync();
      const u = new URL(location.href);
      ['for', 'style', 'budget'].forEach((k) => { if (state[k]) u.searchParams.set(k, state[k]); else u.searchParams.delete(k); });
      history.replaceState(null, '', u);
      Promise.all([load(d.src), firstCards, asked() ? allCards() : null]).then(([rows]) => draw(rows));
    };

    groups.forEach((g) => g.querySelectorAll('[data-v]').forEach((b) => b.addEventListener('click', () => {
      const k = g.dataset.cbQ;
      state[k] = state[k] === b.dataset.v && g.dataset.toggle ? '' : b.dataset.v;
      shown = PAGE;
      update();
    })));

    more.addEventListener('click', () => { shown += PAGE; Promise.all([load(d.src), allCards()]).then(([rows]) => draw(rows)); });
    // Fetched cards missed the theme's binding: forward quick view / quick add to the bound stand-ins, mirror the hover photo.
    const proxy = { view: root.querySelector('[data-cb-proxy="view"]'), add: root.querySelector('[data-cb-proxy="add"]') };
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-quick-shop-trigger]');
      if (!t || t.hasAttribute('data-cb-proxy')) return;
      const kind = t.dataset.quickShopTrigger === 'quick-add' ? 'add' : 'view';
      if (!proxy[kind]) return;
      e.preventDefault();
      e.stopPropagation();
      if (kind === 'add') proxy.add.dataset.productId = t.dataset.productId || '';
      else proxy.view.dataset.productUrl = t.dataset.productUrl || '';
      proxy[kind].click();
    }, true);
    const hover = (on) => (e) => {
      const item = e.target.closest('.cb-ff__item .product-item');
      if (!item || item.contains(e.relatedTarget)) return;
      const two = item.querySelector('.product-item__image--two');
      if (two) two.classList.toggle('active', on);
    };
    root.addEventListener('mouseover', hover(true));
    root.addEventListener('mouseout', hover(false));
    // Start fetching the rest as soon as the visitor reaches for the questions.
    ['pointerover', 'focusin', 'touchstart'].forEach((ev) => root.addEventListener(ev, () => allCards(), { once: true, passive: true }));

    root.querySelectorAll('[data-cb-chat]').forEach((b) => b.addEventListener('click', () => window.cbOpenChat()));

    update();
  });
})();
